"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnoozeTypesEnum = exports.AlertTypesEnum = void 0;
const AlertTypesEnum = exports.AlertTypesEnum = {
  MAIL: 1,
  SMS: 2,
  GENERAL: 3
};
const SnoozeTypesEnum = exports.SnoozeTypesEnum = {
  FIVE_MINUTES: 5,
  TEN_MINUTES: 10,
  FIFTEEN_MINUTES: 15,
  THIRTY_MINUTES: 30,
  ONE_HOUR: 60,
  TWO_HOURS: 120,
  FOUR_HOURS: 240,
  EIGHT_HOURS: 480,
  ONE_DAY: 1440
};